export default __webpack_public_path__ + "static/Plots0069-bd9afe76de14d7ff99c4d6399ec810ae.jpg";